import { CURRENT_YEAR } from '../styles/tokens';

interface SeasonYearsPayload {
  currentSeason?: number;
  activeSeason?: number;
}

interface FeatureStatusPayload {
  livePolls?: boolean;
  pollVoting?: boolean;
  pollStudio?: boolean;
  cachedExplainers?: boolean;
  explainerGeneration?: boolean;
}

interface FrontendStatusPayload {
  built?: boolean;
}

export interface AppStatusPayload {
  years?: SeasonYearsPayload;
  features?: FeatureStatusPayload;
  frontend?: FrontendStatusPayload;
}

export interface AppFeatureStatus {
  livePolls: boolean;
  pollVoting: boolean;
  pollStudio: boolean;
  cachedExplainers: boolean;
  explainerGeneration: boolean;
}

export interface AppStatusState {
  currentSeasonYear: number;
  activeSeasonYear: number;
  resolved: boolean;
  seasonOptions: number[];
  frontendBuilt: boolean;
  features: AppFeatureStatus;
}

const HISTORY_START_YEAR = 1950;

function buildSeasonOptions(endYear: number) {
  const seasons = [];
  for (let year = Math.max(endYear, HISTORY_START_YEAR); year >= HISTORY_START_YEAR; year -= 1) {
    seasons.push(year);
  }
  return seasons;
}

export function buildAppStatusState(status: AppStatusPayload | null, fallbackYear = CURRENT_YEAR): AppStatusState {
  const currentSeasonYear = Number(status?.years?.currentSeason) || fallbackYear;
  const activeSeasonYear = Number(status?.years?.activeSeason) || currentSeasonYear;

  return {
    currentSeasonYear,
    activeSeasonYear,
    resolved: Boolean(status?.years?.currentSeason || status?.years?.activeSeason),
    seasonOptions: buildSeasonOptions(currentSeasonYear),
    frontendBuilt: Boolean(status?.frontend?.built),
    features: {
      livePolls: Boolean(status?.features?.livePolls),
      pollVoting: Boolean(status?.features?.pollVoting),
      pollStudio: Boolean(status?.features?.pollStudio),
      cachedExplainers: Boolean(status?.features?.cachedExplainers),
      explainerGeneration: Boolean(status?.features?.explainerGeneration),
    },
  };
}
